module.exports = __webpack_public_path__ + "img/link-handbook-desktop_cn.7977cdd.jpg";